<template>
  <div>
    <!-- 检品状态详情 -->
    <el-dialog :title="$t('message.inspectionStatusDetails')" :close-on-click-modal="false"
      :visible.sync="dialogVisible" width="1200px" center>
      <div class="content">
        <div class="table">
          <ol>
            <!-- 检品单号 -->
            <li class="flex15">
              {{ $t("message.inspectionOrderNumber") }}
            </li>
            <!-- 检品员 -->
            <li>
              {{ $t("message.inspector") }}
            </li>
            <!-- 番号 -->
            <li>
              {{ $t("message.mash") }}
            </li>
            <!-- 图片 -->
            <li>
              {{ $t("message.picture") }}
            </li>
            <!-- 应检数 -->
            <li>
              {{ $t("message.numberToBeChecked") }}
            </li>
            <!-- 实检数 -->
            <li>
              {{ $t("message.checkNumber") }}
            </li>
            <!-- 提交检品时间 -->
            <li>
              {{ $t("message.submitInspectionTime") }}
            </li>
            <!-- 检品完成时间 -->
            <li>
              {{ $t("message.inspectionCompletionTime") }}
            </li>
            <!-- 当前状态 -->
            <li>
              {{ $t("message.currentState") }}
            </li>
          </ol>
          <ul v-for="(item, index) in tableData" :key="index">
            <!-- 检品单号 -->
            <li class="flex15">
              {{ item.inspect_sn }}
            </li>
            <!-- 检品员 -->
            <li>
              {{ item.j_realname }}
            </li>
            <!-- 番号 -->
            <li>
              {{ item.sorting }}
            </li>
            <!-- 图片 -->
            <li>
              <el-popover placement="right" width="300" trigger="hover">
                <img :src="item.pic" alt="" style="width: 300px; height: 300px" />
                <a :href="`https://detail.1688.com/offer/${item.goods_id}.html`" target="_blank" slot="reference">
                  <img :src="item.pic" alt="" style="width:60px" />
                </a>
              </el-popover>
            </li>
            <!-- 应检数 -->
            <li>
              {{ item.num }}
            </li>
            <!-- 实检数 -->
            <li>
              <div class="template">
                <!-- 实检数 -->
                <p>
                  {{ $t("message.checkNumber") }}:{{
      item.inspect_num
    }}
                </p>
                <!-- 数量差 -->
                <p>
                  {{ $t("message.poorQuantity") }}:{{
      item.num - item.inspect_num
    }}
                </p>
                <!-- 不良数 -->
                <p>
                  {{ $t("message.adverseNumber") }}:{{
      item.inspect_bad_num
    }}
                </p>
              </div>
            </li>
            <!-- 提交检品时间 -->
            <li>
              {{ item.submit_at }}
            </li>
            <!-- 检品完成时间 -->
            <li>
              {{ item.inspect_at }}
            </li>
            <!-- 当前状态 -->
            <li>
              {{ item.status_name }}
            </li>
          </ul>
          <!-- 暂无数据 -->
          <div class="noData" v-if="tableData == false">
            暂无数据
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>

export default {
  props: {
    order_purchase_id: { type: Number },
  },
  data() {
    return {
      tableData: [],
      dialogVisible: false,
    };
  },
  methods: {

  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible) {
        this.$api.inspectionApi.inspectListByPurchase({ order_purchase_id: this.order_purchase_id }).then(res => {
          this.tableData = res.data
        })
      }
    }
  }
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;

  .row {
    display: flex;
    margin-bottom: 20px;

    .label {
      line-height: 40px;
    }

    .val {
      flex: 3;
    }
  }

  .table {
    border: 1px solid #edeff4;

    ol {
      display: flex;
    }

    ul {
      display: flex;
      padding: 0;
      border: 0;

      li {
        padding: 24px 10px;
        text-align: center;

      }

      .template {
        width: 100%;
        text-align: left;
      }
    }

    li {
      border-right: 1px solid #edeff4;

      &:nth-last-child(1) {
        border: 0;
      }
    }

    .noData {

      margin: 30px auto;
      text-align: center;
      font-size: 18px;
    }

    .flex15 {
      flex: 1.5;
    }
  }


}
</style>